module.exports = __webpack_public_path__ + "static/media/not-equal.b94eb30d.svg";